import { useEffect, useState } from 'react'
import { ReactComponent as LirariLandingPageMobileLogo } from './../../assets/images/lirari-landing-page-mobile-logo.svg'
import { useAuth0 } from '@auth0/auth0-react'
import { isEmailBeingVerifiedAtom } from '../../State/Musician/isEmailBeingVerifiedAtom'
import { useAtom } from 'jotai'

const EmailVerifiedPage = () => {
  const { loginWithRedirect } = useAuth0()
  const [countdown, setCountdown] = useState(3)
  const [, setIsEmailBeingVerified] = useAtom(isEmailBeingVerifiedAtom)

  useEffect(() => {
    setIsEmailBeingVerified(true)
  }, [setIsEmailBeingVerified])

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => {
        setCountdown((prev) => prev - 1)
      }, 1000)
      return () => clearTimeout(timer)
    } else {
      const redirectTimeout = setTimeout(() => {
        loginWithRedirect({
          appState: { returnTo: '/redirect' },
        })
      }, 500)
      return () => clearTimeout(redirectTimeout)
    }
  }, [countdown, loginWithRedirect])

  return (
    <div className="bg-white flex flex-col min-h-screen px-4">
      <div className="flex justify-center items-center py-4 sm:py-6 md:py-8">
        <LirariLandingPageMobileLogo className="h-36 sm:h-48 md:h-64" />
      </div>
      <div className="flex-1 flex justify-center items-center pb-8">
        <div className="w-full max-w-md flex flex-col items-center text-center">
          <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-6">Email Verified!</h1>
          <p className="text-lg sm:text-xl text-black mb-4">Thank you for verifying your email.</p>
          <p className="text-base sm:text-lg text-black mb-8">
            Signing you in automatically in {countdown} {countdown === 1 ? 'second' : 'seconds'}...
          </p>

          <div className="flex items-center justify-center mb-8">
            <div className="animate-spin h-8 w-8 border-4 border-[#8830C7] border-t-transparent rounded-full"></div>
          </div>

          <div className="w-full">
            <button
              onClick={() => {
                loginWithRedirect({
                  appState: { returnTo: '/redirect' },
                })
              }}
              className="bg-[#8830C7] text-white py-3 px-6 rounded-full hover:bg-[#8830C7]/90 transition-colors text-base sm:text-lg w-full"
            >
              Sign in Now
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EmailVerifiedPage
